module.exports = __webpack_public_path__ + "img/telephone-payment.db057ac.svg";